import { Metric } from "@/design-system";
import { cn } from "@/utils";
import type { SourcedFact } from "../types";

type SourcedMetricGridProps = {
  facts: SourcedFact[];
  className?: string;
};

/** Números com a fonte visível embaixo — nunca número solto sem origem. */
export const SourcedMetricGrid = ({
  facts,
  className,
}: SourcedMetricGridProps) => (
  <ul
    className={cn(
      "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3",
      className
    )}
  >
    {facts.map(fact => (
      <li key={fact.label}>
        <Metric value={fact.value} label={fact.label} hint={fact.source} />
      </li>
    ))}
  </ul>
);
